import { CalendlyExpert } from '@/features/experts/types/CalendlyExpert';
import { TimeSlot } from '@/features/experts/types/TimeSlot';
import { getEventTypeByRole } from '@/features/experts/utils/getUrlSuffix';
import { formatDateForCalendly, formatPhoneNumber } from '../utils/dateFormatters';

interface UseVenereCalendlyUrlProps {
  expert: CalendlyExpert;
  selectedDate: string | null;
  selectedSlot: TimeSlot | null;
  userData: {
    email: string | null;
    name: string;
    familyName: string;
    phoneNumber?: string;
  };
}

export const useVenereCalendlyUrl = ({ expert, selectedDate, selectedSlot, userData }: UseVenereCalendlyUrlProps) => {
  // Get the event type for this expert based on their role
  const eventType = getEventTypeByRole(expert.email);

  // Construct the Calendly URL with the selected date and time
  const calendlyUrl = selectedSlot && selectedDate
    ? `${expert.calendly_data.calendly_user.scheduling_url}/${eventType || ''}/${formatDateForCalendly(selectedDate, selectedSlot.start_time)}?back=1&month=${selectedDate.substring(0, 7)}&date=${selectedDate}`
    : `${expert.calendly_data.calendly_user.scheduling_url}/${eventType || ''}`;

  // Create answers object for phone number
  const answers = userData.phoneNumber ? {
    "phone": formatPhoneNumber(userData.phoneNumber)
  } : {};

  // Construct the full URL with user data
  const separator = calendlyUrl.includes('?') ? '&' : '?';
  const fullUrl = `${calendlyUrl}${separator}email=${encodeURIComponent(userData.email || '')}&name=${encodeURIComponent(`${userData.name} ${userData.familyName}`)}${Object.keys(answers).length > 0 ? `&answers=${encodeURIComponent(JSON.stringify(answers))}` : ''}`;

  return { fullUrl };
}; 